import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth-guard.service';
import { ACCOUNT, ADMIN, MY, ROOT } from './core/routes/route-strings';
import { UnauthGuard } from './core/unauth-guard.service';
import { LandingComponent } from './landing/landing.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SafetyStandardsComponent } from './safety-standards/safety-standards.component';
import { TosComponent } from './tos/tos.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivate: [UnauthGuard],
    loadChildren: () =>
      import('./account/components/social-login/social-login.routes').then(
        (m) => m.SOCIAL_LOGIN_ROUTES
      ),
  },
  {
    path: ROOT.PRIVACY_POLICY,
    component: PrivacyPolicyComponent,
    title: 'Privacy Policy',
  },
  {
    path: ROOT.TOS,
    component: TosComponent,
    title: 'Terms of Use',
  },
  {
    path: ROOT.SAFETY_STANDARDS,
    component: SafetyStandardsComponent,
    title: 'Safety Standards',
  },
  {
    path: ACCOUNT.ROOT,
    loadChildren: () =>
      import('./account/account.routes').then((m) => m.ACCOUNT_ROUTES),
    canActivate: [UnauthGuard],
  },
  {
    path: MY.ROOT,
    loadChildren: () => import('./my/my.routes').then((m) => m.MY_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: ADMIN.ROOT,
    loadChildren: () =>
      import('./admin/admin-routing.module').then((m) => m.ADMIN_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
